import { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { exchangeGoogleCalendarCode } from "../../store/middleware";

function GoogleCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [status, setStatus] = useState({ loading: true, message: "" });

  const code = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("code");
  }, [location.search]);

  useEffect(() => {
    const run = async () => {
      if (!code) {
        setStatus({ loading: false, message: "Código de autorização não encontrado." });
        return;
      }

      try {
        const payloads = {
          code,
          user: { id: user?.id },
        };

        const response = await dispatch(exchangeGoogleCalendarCode(payloads));
        const { connected, hasRefreshToken } = response?.result?.items?.[0] || {};

        if (connected) {
          sessionStorage.setItem("@googleCalendarConnected", "true");
          setStatus({
            loading: false,
            message: hasRefreshToken
              ? "Google Calendar conectado com sucesso."
              : "Conexão realizada, mas pode ser necessário reconectar.",
          });
        } else {
          setStatus({ loading: false, message: "Não foi possível conectar o Google Calendar." });
        }
      } catch (e) {
        setStatus({ loading: false, message: "Não foi possível conectar o Google Calendar." });
      }

      navigate("/manage-account/notification");
    };

    run();
    // eslint-disable-next-line
  }, [code]);

  return (
    <div style={{ width: "100%", padding: 24, display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: 520 }}>
        <h2 style={{ margin: 0, color: "#403F4C" }}>{t("MANAGE_ACCOUNT_TITLE")}</h2>
        <p style={{ marginTop: 12, color: "#6D6A75" }}>{status.loading ? "Conectando..." : status.message}</p>
        <button onClick={() => navigate("/manage-account/notification")}>Voltar</button>
      </div>
    </div>
  );
}

export default GoogleCallback;
